import mitt from 'mitt'

const emitter = mitt()

export const API_REQUEST = 'API_REQUEST'

export default emitter
